// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__6rS3w","label":"Section_label__2jjOR","contentWrap":"Section_contentWrap__c4sfe","footer":"Section_footer__rcCZP","footerInner":"Section_footerInner__1Hygp"};